import AmericanKpisBox from "components/company/v3/american/boxes/AmericanKpisBox";
import AmericanPageLayout from "components/company/v3/layouts/AmericanPageLayout";
import { KpisTabEnum } from "components/company/v3/menu/enums";
import AmericanIssuerSeo from "components/company/v3/seo/AmericanIssuerSeo";
import SetHttpStatusCode from "lib/http/SetHttpStatusCode";
import getQueryStringValue from "lib/utils/getQueryStringValue";
import type { NextPage } from "next";
import { parseAsStringEnum, useQueryState } from "nuqs";
import NotFound from "pages/404";
import { useIntl } from "react-intl";

interface KpisPageProps {
  tickerSymbol: string | null;
}

const KpisPage: NextPage<KpisPageProps> = function KpisPage({ tickerSymbol }) {
  const intl = useIntl();
  const [tab, setTab] = useQueryState(
    "tab",
    parseAsStringEnum<KpisTabEnum>(Object.values(KpisTabEnum)).withDefault(KpisTabEnum.TABLE),
  );

  const normalizedTickerSymbol = (tickerSymbol || "").toUpperCase();
  if (!normalizedTickerSymbol || normalizedTickerSymbol.length > 8 || /^([0-9]+)$/.test(normalizedTickerSymbol)) {
    return (
      <>
        <SetHttpStatusCode httpStatus={404} />
        <NotFound />
      </>
    );
  }

  return (
    <AmericanPageLayout tickerSymbol={normalizedTickerSymbol}>
      <AmericanIssuerSeo
        title={intl.formatMessage({
          defaultMessage: "KPIs",
          description: "Título da página - SEO",
          id: "gUknBo",
        })}
      />

      <AmericanKpisBox tickerSymbol={normalizedTickerSymbol} tab={tab} onChangeTab={setTab} />
    </AmericanPageLayout>
  );
};

KpisPage.getInitialProps = async ({ query }) => ({
  tickerSymbol: getQueryStringValue(query, "tickerSymbol"),
});

export default KpisPage;
